import { NAV_ITEMS, PROPERTY_DETAILS_TAB_NAMES } from '@/constants';
import { usePropertyDetails } from '@/utils/hooks/data/usePropertyDetails';
import { ClickableText, Data, UncoloredLink, Value } from '../shared/styles';

interface Props {
  streetAddress: string;
  propertyDeckardId?: string | null;
}

export function ComplaintStreetAddress(props: Props) {
  const { generatePropertyDetailsLink } = usePropertyDetails();

  return (
    <Data data-cy="complaint-details-complaint-supplied-address">
      <div>Supplied Address</div>

      {props?.propertyDeckardId ? (
        <UncoloredLink
          to={generatePropertyDetailsLink({
            propertyDeckardId: props.propertyDeckardId,
            tab: NAV_ITEMS.home,
            propertyDetailsTab: PROPERTY_DETAILS_TAB_NAMES.overview,
          })}
        >
          <ClickableText>{props.streetAddress}</ClickableText>
        </UncoloredLink>
      ) : (
        <Value>{props.streetAddress}</Value>
      )}
    </Data>
  );
}
